import React from 'react';
import { useEditController, useRefresh } from 'react-admin';
import { AgendaForm } from './AgendaForm';
import { Edit } from '../../components/Edit';
import { RecordEditTitle } from '../../components/RecordTitle';
import { transformMediaUrlInput } from '../../lib/media/makeUrl'
import { fromGenericToUTC } from '../../lib/i18n/utils';

export const AgendaEdit = (props: any) => {
  const { record, isLoading } = useEditController();
  const refresh = useRefresh();
  const transform = data => ({
    ...data,
    publishedAt: fromGenericToUTC(data.publishedAt),
    newsIds: data.newsIds ?? [],
    topicIds: data.topicIds ?? [],
    sectorIds: data.sectorIds ?? [],
    mediaUrl: transformMediaUrlInput(data.mediaUrl)
  });

  React.useEffect(() => {
    if (record && record.id) {
      refresh();
    }
  }, [record, refresh]);

  if (isLoading || !record.createdBy) return null;

  return (
    <Edit mutationMode='pessimistic' meta={{ embed: 'media,topics,sectors' }} title={<RecordEditTitle property="title" />} {...props} transform={transform}>
      <AgendaForm hideSendPushNotification username={record.createdBy.name} />
    </Edit>
  )
};
